import type { OrganizationType } from "../../lib/types";

const organizationTypes: { value: OrganizationType; label: string }[] = [
  { value: "BRAND_OWNER", label: "Brand owner" },
  { value: "AGENCY", label: "Agency" },
  { value: "PRINTER", label: "Printer" },
  { value: "RECCE", label: "Recce" },
  { value: "DESIGN", label: "Design" },
  { value: "SMB", label: "SMB" }
];

export default function OrganizationTypeField({
  value,
  onChange,
  disabled
}: {
  value: OrganizationType | "";
  onChange: (value: OrganizationType | "") => void;
  disabled?: boolean;
}) {
  return (
    <label>
      <span>Organization type</span>
      <select
        required
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value as OrganizationType | "")}
      >
        <option value="">Select organization type</option>
        {organizationTypes.map((type) => <option key={type.value} value={type.value}>{type.label}</option>)}
      </select>
    </label>
  );
}
